import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import * as css from './reg-item-form.scss'
import ImageUploadPreviewer from 'shared/image-upload-previewer/image-upload-previewer'
import { CurrencyInput, Input } from 'components/forms'
import FavoriteToggle from 'shared/reg-item-form/components/favorite-toggle'
import Checkbox from 'components/forms/checkbox'
import CategorySelector from './category-selector'

export default class CashFundFields extends Component {
  static propTypes = {
    categories: PropTypes.array,
    regItem: PropTypes.object,
    onRegItemChange: PropTypes.func.isRequired,
    onNewCategoryChange: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      originalGoalAmount: props.regItem.goalAmount || 100,
    }
  }

  clearGoalAmount = (e) => {
    if (e.target.checked) {
      this.props.onRegItemChange({ goalAmount: null })
    } else {
      this.props.onRegItemChange({ goalAmount: this.state.originalGoalAmount })
    }
  }

  onFavoriteChange = (isChecked) => {
    this.props.onRegItemChange({ isFavorite: isChecked })
  }

  onImageChange = ({ imgUrl }) => {
    this.props.onRegItemChange({ imgUrl })
  }
  handleChange = (e) => {
    this.props.onRegItemChange({ [e.target.name]: e.target.value })
  }

  render() {
    const regItemFields = this.props.regItem

    return (
      <React.Fragment>
        <div className={css.item}>
          <div className={css.imageContainer}>
            <ImageUploadPreviewer
              imgUrl={regItemFields.imgUrl}
              onChange={this.onImageChange}
            />
          </div>

          <div className={css.itemFields}>
            <Input
              label="Title"
              value={regItemFields.title}
              onChange={this.handleChange}
              name="title"
              error={regItemFields.title ? null : 'Title cannot be blank'}
            />

            <div className="inline-form">
              <CurrencyInput
                label="Goal"
                value={
                  regItemFields.goalAmount != null
                    ? regItemFields.goalAmount
                    : 0
                }
                onChange={this.handleChange}
                name="goalAmount"
                groupClassName={css.flexGrow}
              />
              <Checkbox
                label="No Goal"
                name="noGoal"
                style={{ whiteSpace: 'nowrap' }}
                onChange={this.clearGoalAmount}
                groupClassName={classNames(css.flexGrow, css.noGoal, 'mll')}
                checked={!regItemFields.goalAmount}
              />
            </div>

            <div className="inline-form">
              <CategorySelector
                groupClassName={css.flexGrow}
                name="categoryId"
                value={regItemFields.categoryId}
                categories={this.props.categories}
                onCategoryChange={this.props.onRegItemChange}
                onCategoryAdd={this.props.onNewCategoryChange}
              />
              <FavoriteToggle
                className={css.flexGrow}
                defaultOn={this.props.regItem.isFavorite}
                onClick={this.onFavoriteChange}
              />
            </div>
          </div>
        </div>

        <Input
          label="Notes for friends and family"
          type="textarea"
          onChange={this.handleChange}
          name="description"
          value={regItemFields.description || ''}
          className={classNames(css.notes)}
          placeholder="Let everyone know why this is important."
        />
      </React.Fragment>
    )
  }
}
